function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Socket } from "phoenix";
import Hash from "../../../utils/hash";
export default {
  data: function data() {
    return {
      _wsSocket: null
    };
  },
  methods: {
    $wsInitPhoenixSocket: function $wsInitPhoenixSocket(spec) {
      var _this = this;

      Utils.type.ifObject(spec, function (ws) {
        console.log("Connecting socket...");
        Utils.launch.snackbar.indicator("Connecting...");
        Utils.http.startIndicator(_this); // Without this, at times the indicator doesn't disappear because there isn't enough delay
        // between startIndicator() and stopIndicator()

        setTimeout(function () {
          _this._wsConnectSocket(ws);
        }, 100);
      }, function () {
        _this._wsDisconnectSocket();
      });
    },
    // https://medium.com/@imiked/real-time-feature-with-phoenix-and-vue-js-c7677663a6f5
    _wsConnectSocket: function _wsConnectSocket(spec) {
      var _this2 = this;

      var host = Utils.settings.isDev ? "ws://localhost:4019" : "wss://prod.com"; // const host = Utils.settings.isDev
      //   ? "ws://192.168.1.109:4019"
      //   : "wss://prod.com";
      // const url = Utils.url.appendParams(
      //   `${host}${conf.endpoint}?`,
      //   conf.params
      // );

      var conf = spec.socket; // See https://github.com/phoenixframework/phoenix/blob/master/assets/js/phoenix.js

      var endpoint = "".concat(host).concat(conf.endpoint).replace(/\/websocket$/, "");
      var params = new Hash(conf.params);
      var version = params.remove("vsn");
      var socket = new Socket(endpoint, {
        params: params,
        vsn: version
      });
      this._wsSocket = socket;
      socket.onOpen(function () {
        console.log("Connected socket");

        _this2._wsJoinChannel(socket, spec);

        Utils.http.stopIndicator(_this2);
      });
      socket.onError(function () {
        // Start the indicator again because this can trigger even after successfully connected.
        Utils.http.startIndicator(_this2);
        console.log("Unable to connect socket");
      });
      socket.connect();
    },
    _wsJoinChannel: function _wsJoinChannel(socket, spec) {
      var _this3 = this;

      var ws = window.vueApp.webSocket;
      Utils.type.ifObject(spec.header, function (header) {
        ws.header = header;
      });
      var topicName = spec.topic;
      var events = spec.events;

      if (!Utils.type.isString(topicName) || !Utils.type.isArray(events)) {
        return;
      }

      var channel = socket.channel(topicName, {});

      var _iterator = _createForOfIteratorHelper(events),
          _step;

      try {
        var _loop = function _loop() {
          var eventName = _step.value;
          console.log("Registering event '".concat(eventName, "'"));
          channel.on(eventName, function (payload) {
            console.debug("Received '".concat(eventName, "' event"), payload);
            Utils.ws.handleResponse(payload.onResponse, _this3);
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      channel.join().receive("ok", function (resp) {
        console.log("Channel joined '".concat(topicName, "'"), resp);
        ws.channels[topicName] = channel;
      }).receive("error", function (resp) {
        console.log("Unable to join channel '".concat(topicName, "'"), resp);
        Utils.launch.snackbar.error("Unable to connect. Please try again.", _this3);
      });
    },
    _wsDisconnectSocket: function _wsDisconnectSocket() {
      if (this._wsSocket) {
        console.log("Disconnecting socket"); // Sometimes this doesn't prevent errorneous socket from trying to reconnect. In this case,
        // the socket will keep attempting to connect.

        this._wsSocket.disconnect();

        this._wsSocket = null;
        var ws = window.vueApp.webSocket;
        ws.channels = {};
        ws.header = {};
        Utils.http.stopIndicator(this);
      }
    }
  }
};